import uuid4 from "uuid4"

export const usePageViewId = () => useState<string>("pageViewId", () => uuid4())
